import { jsPDF } from 'jspdf';
import { addCanvasToSinglePagePdf, captureVoucherElement } from '../shared/voucherPdfUtils';

export const exportHotelVoucherPdfFromElement = async (element, data) => {
    if (!element || !data) return;

    const canvas = await captureVoucherElement(element);

    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
    addCanvasToSinglePagePdf(pdf, canvas, imgData);

    pdf.save(`Hotel_Voucher_${data.ConfirmationId || 'voucher'}.pdf`);
};
